<template>
    <div class="mt-3">
        <div class="card col-12 col-md-8 offset-md-2 p-4">
            <h1>{{ $t('auth.profile.invoice_info') }}</h1>
            <div class="row" v-if="is_company">
                <div class="col-12">
                    <form action="/updateInvoiceData" method="POST" @submit.prevent="handleSubmit">
                        <div class="form-group col-12">
                            <label for="companyName">{{ $t('auth.profile.company_name') }}</label>
                            <input id="companyName" type="text" class="form-control" name="company_name" v-model="company_name">
                        </div>

                        <div class="form-group col-12">
                            <label for="address">{{ $t('auth.profile.address') }}</label>
                            <input id="address" type="text" class="form-control" name="address" v-model="address">
                        </div>

                        <div class="form-group col-12">
                            <label for="taxNumber">{{ $t('auth.profile.tax_number') }}</label>
                            <input id="taxNumber" type="number" class="form-control" name="tax_number" v-model="tax_number">
                        </div>

                        <div class="form-group col-12">
                            <label>{{ $t('auth.profile.phone') }}</label>

                            <phone-input
                                input-class="form-control"
                                :value="phone"
                                @input="onPhoneInput($event)"
                            />
                        </div>

                        <div class="form-group col-12">
                            <label for="post_code">{{ $t('auth.profile.post_code') }}</label>
                            <input id="post_code" type="text" class="form-control" name="post_code" v-model="post_code">
                        </div>

                        <div class="form-group col-12">
                            <label for="city">{{ $t('auth.profile.city') }}</label>
                            <input id="city" type="text" class="form-control" name="city" v-model="city">
                        </div>

                        <div class="form-group col-12">
                            <label for="country">{{ $t('auth.profile.country') }}</label>
                            <input id="country" type="text" class="form-control" name="country" v-model="country">
                        </div>

                        <div class="form-group col-12">
                            <button type="submit" class="btn btn-primary">{{ $t('send') }}</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import toastr from 'toastr';
    import UserRepository from '@repositories/UserRepository';

    export default {
        name: 'Profile',
        data() {
            return {
                is_company: this.$store.state.user.is_company,
                company_name: this.$store.state.user.company_name,
                address: this.$store.state.user.address,
                tax_number: this.$store.state.user.tax_number,
                phone: this.$store.state.user.phone,
                post_code: this.$store.state.user.post_code,
                city: this.$store.state.user.city,
                country: this.$store.state.user.country,
            };
        },

        methods: {
            handleSubmit() {
                let data = {
                    company_name: this.company_name,
                    address: this.address,
                    tax_number: this.tax_number,
                    phone: this.phone,
                    post_code: this.post_code,
                    city: this.city,
                    country: this.country,
                };

                UserRepository.updateInvoiceData(data)
                    .then(() => {
                        toastr.success(this.$t('data_updated_success'));
                    });
            },

            onPhoneInput(value) {
                this.phone = value;
            },
        },
    };
</script>
